import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=73f7251a&scoped=true"
import script from "./LegalInformation.vue?vue&type=script&lang=js"
export * from "./LegalInformation.vue?vue&type=script&lang=js"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=73f7251a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f7251a",
  null
  
)

export default component.exports